import React, { useEffect, useState } from 'react';
import { Routes,Route, useNavigate } from 'react-router-dom';

import MobileOTP from './folder/screens/auth/Mobile';
import ForgotPassword from './folder/screens/auth/ForgotPassword';
import UpdatePassword from './folder/screens/auth/UpdatePassword';
import './App.css';

import Login from './folder/screens/auth/Login';
import { routes } from './folder/components/routes/router';

import { Toaster } from 'react-hot-toast';
import { useLocation } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';

import {AiOutlineSetting} from 'react-icons/ai';
import {FiUser} from 'react-icons/fi';
import {MdOutlineSpaceDashboard} from 'react-icons/md';
import {SiGoogleadsense} from 'react-icons/si';
import { HiOutlineArchive } from "react-icons/hi";
import {HiLogout} from 'react-icons/hi';
import {HiOutlineMenuAlt4} from 'react-icons/hi';
import { LogOutAction } from './folder/redux/actions/authAction';
import { Drawer } from 'antd';
import { RiBillLine } from 'react-icons/ri';
import { FaRegUser } from 'react-icons/fa';
import logo from '../src/folder/images/person.png'
import Splash from './folder/screens/Splash';
import { IoMdClose } from "react-icons/io";
import { CgToday } from "react-icons/cg";
import { LiaGoogleDrive } from "react-icons/lia";
import PrivateRoute from './folder/components/routes/PrivateRoute';


function App() {

  const [step,setstep] = useState(1)
  const [loader,setloader] = useState(true)

  const location = useLocation()
  const {pathname} = useLocation()
  const auth = useSelector(state=>state.Auth)
  const [drawer_menu,setdrawer_menu] = useState(false)
  const dispatch = useDispatch()

  const path = pathname.split('/')[1]
  

  useEffect(()=>{
     setTimeout(() => {
       setloader(false)
     }, 2500);
  },[])

  const navigate = useNavigate()

  const [mobileOpen, setMobileOpen] = useState(false);

  const disabled_drawer = ['/','/login','/forgot_password','/update_password','/password_reset','/privacy',]

  const userRoute = [
    { name: "Dashboard", to: "/dashboard", icon: MdOutlineSpaceDashboard ,size:18,roles:['bd_user','manager','hod','admin']},
    { name: "Case", to: "/case", icon: SiGoogleadsense ,size:18,roles:['hod','manager','bd_user']},
    { name: "Opinion Files", to: "/opinion_files", icon: RiBillLine ,size:18,roles:['admin','manager','user']},
    { name: "Client", to: "/client", icon: FaRegUser ,size:16,roles:['admin','manager','user']},
    { name: "Bills", to: "/bills", icon: HiOutlineArchive ,size:18,roles:['admin','manager','user']},
    { name: "Today Work", to: "/today_work", icon: CgToday ,size:18,roles:['admin','manager','user']},
    // { name: "Drive", to: "/drive", icon: LiaGoogleDrive ,size:18,roles:['admin','manager','user']},
    { name: "Drive", to: "/drive/drive_link", icon: LiaGoogleDrive ,size:18,roles:['admin','manager','user']},
    { name: "Profile", to: "/profile", icon: FiUser,size:19,roles:[]},
    { name: "Settings", to: "/settings", icon: AiOutlineSetting,size:16,roles:['admin','controller']},
  ];

 

  // console.log("path",path)


  function gotodashboard(){
    navigate('/dashboard')
  }

 

  const handleLogout = () => {
    dispatch(LogOutAction())
    navigate("/",{ replace: true });
  };

 



  const drawer = (
    <div className={`relative bg-[#1b3f69] min-h-screen `}>
      <div className='grid group place-items-center border-b border-slate-400 py-3'>
      <img onClick={gotodashboard} className='w-6 h-6 flex items-center opacity-50 group-hover:opacity-100' src={logo} />
      <h6 className='text-[8px] mt-1 group-hover:opacity-100 text-white font-sans font-[900] opacity-50'>ADVOCATE</h6>
      </div>
      {userRoute?.map((item) => (
         <React.Fragment key={item?.to}>
            <div key={item?.name}>
              <div className={`grid py-1.5 place-items-center  text-black  mb-1 cursor-pointer ${path === item?.to?.split('/')[1] ? 'opacity-100 text-black bg-white ' : 'text-white opacity-70'}  ${path === item?.to?.split('/')[1] && 'opacity-100'} `} onClick={()=>{navigate(item.to);setMobileOpen(false)}}>
                {item.icon && <item.icon size={item.size}  /> }
                <span className="mt-1 text-[9px] font-[600]">
                  {item.name} 
                </span>
              </div>
            </div>  
          </React.Fragment>   
      ))}

      <div className="grid  bottom-0 py-2 border-white place-items-center opacity-70 hover:opacity-100 text-white  mb-1 cursor-pointer " onClick={handleLogout}>
          <HiLogout size={14}  /> 
          <span className="mt-1 text-[9px] font-[600]">
            {'Log out'}
          </span>
      </div>       
    </div>
  );

  // console.log("path",path)

  return (
    <div className=' md:w-screen md:overflow-x-hidden'>
   
      {!loader ?
      <div className="relative  md:flex md:w-full md:border-box">

          {!disabled_drawer.includes(location.pathname) && (
          <>
            <div className={`hidden md:block ${step === 1 ? 'min-w-[70px]  w-[70px] max-w-[70px]' : 'min w-[140px] '} `}>
              {drawer}
            </div>
          </>
         )}

         {!disabled_drawer.includes(location.pathname) && (
         <div className='flex md:hidden justify-between items-center bg-[#1b3f69] text-white py-[15px] px-2'>
          <div onClick={gotodashboard} className='flex items-center'>
            <img  className='w-6  h-6 flex items-center -mt-0.5  hover:opacity-100' src={logo} />
            <h6 className='ml-4 text-[12.5px] tracking-wider text-[#fff] uppercase font-[600]'>Dashboard</h6>
          </div>
          <HiOutlineMenuAlt4  className='text-[#fff]' size={20} onClick={()=>setdrawer_menu(!drawer_menu)} /> 
         </div>)}

         <Drawer onClose={()=>setdrawer_menu(false)} maskClosable={true} open={drawer_menu} closable={false} className='-p-[5%]' width={'80%'}>
          <div className='bg-[#1b3f69] h-[100%] py-[16px]'>
          <IoMdClose onClick={()=>setdrawer_menu(false)} size={20} className='absolute top-[5px] left-[-24px] text-white' />
          <div className='flex items-center  px-[5px]'>
            <img onClick={gotodashboard} className='w-6  h-6 flex items-center -mt-0.5  hover:opacity-100' src={logo} />
            <h6 className='ml-4 text-[12.5px] tracking-wider text-[#fff] uppercase font-[600]'>Menu Bar</h6>
          </div>

          <h6 className='p-2 bg-slate-100 text-[12px] mt-2 mb-2'>See the menu option list which was created for you for your daily work.</h6>

          {/*  */}
           {userRoute?.map((item)=>(
             <div className={`flex  px-1 py-2 pl-2 place-items-center  mb-1  cursor-pointer ${path === item?.to?.split('/')[1] ? 'bg-white text-[#1b3f69] opacity-100' : 'text-white opacity-100'}  ${path === item?.to?.split('/')[1] && 'opacity-100'} `} onClick={()=>{setdrawer_menu(false);navigate(item.to);setMobileOpen(false)}}>
             {item.icon && <item.icon size={16}  /> }
             <span className="mt-0 ml-2 text-[12.5px] font-[600]">
               {item.name} 
             </span>
           </div> 
           ))}

            <div className={`flex  absolute bottom-2  px-1 py-1 mx-2 text-black  place-items-center  mb-1 cursor-pointer opacity-50 `} onClick={()=>{setdrawer_menu(false);handleLogout()}}>
             {<HiLogout size={16} className='text-white' /> }
             <span className="mt-1 ml-3 uppercase text-[11.5px] text-white font-[600]">
               Log Out 
             </span>
           </div> 
          </div>
         </Drawer>



  
  
       
  
        {/* <AppBar /> */}
  
       
        {/* <h1 className='ml-20 p-2 bg-slate-400' onClick={()=>toast.success('Hello Im here')}>Amma</h1> */}
  
       
  
        <div className={` bg-gray-0 h-screen relative md:min-w-[95vw] md:w-[95vw] overflow-x-hidden`}>
          <Toaster  position="bottom-center" toastOptions={{
            success: {
              style:{
                background:'black',
                color:'white',
                padding:'4px 7px',
                fontSize:'12px',
                borderRadius:'2px',
                iconTheme: {
                  fontSize:'4px'
                }
              }
            },
            error: {
              style:{
                background:'black',
                color:'white',
                padding:'4px 7px',
                fontSize:'12px',
                borderRadius:'2px',
                iconTheme: {
                  fontSize:'4px'
                }
              }
            }
          }}  />
  
           
       
  

        
          <Routes>
            {routes.map((screen,index) => (
              <Route key={index}  path={screen?.path} exact element={<PrivateRoute roles={screen.roles}  >{screen.component}</PrivateRoute>} />
            ))}
            <Route exact path="/" element={<Login />} />
            <Route exact path="/login" element={<Login />} />
            <Route exact path="/forgot_password" element={<MobileOTP />} />
            <Route exact path="/password_reset?" element={<ForgotPassword />} />
            <Route exact path="/update_password" element={<UpdatePassword />} />
          </Routes>

        
        </div>
      </div>
      :
      <Splash />}

    </div>
  );
}

export default App;
